<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-6 col-sm-4 pb-0 mb-0">
        <img *ngIf="especie === 'CP'" src="assets/img/conta-publica.png" alt="pesquisa" title="" height="32" width="32">
        <img *ngIf="especie === 'PLAN'" src="assets/img/planejamento.png" alt="pesquisa" title="" height="32"
          width="32">
        <span *ngIf="especie === 'CP'" class="titulo-txt-l pl-2">CONTAS PÚBLICAS</span>
        <span *ngIf="especie === 'PLAN'" class="titulo-txt-l pl-2">PLANEJAMENTO</span>
      </div>
      <div class="col-md-6 col-sm-8 pb-0 mb-0">
        <a [routerLink]="['/transparencia']" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="30" width="30">
        </a>
        <a (click)="exportarXLSX()" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/file_xls.png" alt="xls" title="gerar xls" height="30" width="30">
        </a>
        <a (click)="imprimirPDF()" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/file_pdf.png" alt="cvs" title="Gerar pdf" height="30" width="30">
        </a>
        <a [routerLink]="['/']" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/file_xml.png" alt="imprimir" title="Gerar xml" height="30" width="30">
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 pt-0 mt-0">
        <label style="font-weight: bold; color: #757575">
          {{login.orgao.codigo}} {{login.orgao.nome}}
        </label>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="form-group col-sm-4 col-md-3 col-lg-2 col-xl-2">
        <select [(ngModel)]="selectExercicio" (change)="changeAno()" name="selectExercicio"
          style="border: none !important" style="font-weight: bold;" class="custom-select">
          <option [selected]="item.ano === selectExercicio" [value]="item.ano" *ngFor="let item of listaExercicios">
            {{item.ano}}
          </option>
        </select>
      </div>
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5">
        <div class="form-group">
          <select [(ngModel)]="tipo" (change)="preencherGrid()" name="selectSituacao" style="border: none !important"
            style="font-weight: bold;" class="custom-select">
            <option [ngValue]="undefined">Todas</option>
            <option [value]="item.id" *ngFor="let item of listaTipos">
              {{item.nome}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-4 col-md-4 col-lg-5 col-xl-5 mr-0 pr-0">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista.length > 0">
      <div class="col-md">
        <table class="table table-eddy" style="font-size: 13px;">
          <thead>
            <tr style="height: 42px;">
              <th scope="col" class="text-center">
                <a href="javascript:;" (click)="ordenar(1)" class="text-black-50">
                  <span *ngIf="col === 1"><img src="assets/img/global/{{imagem}}" alt="2" height="16"
                      width="16">&nbsp;</span>ANO
                </a>
              </th>
              <th scope="col" class="text-center">
                <span class="text-black-50">REFERÊNCIA</span>
              </th>
              <th scope="col">
                <a href="javascript:;" (click)="ordenar(3)" class="text-black-50">
                  <span *ngIf="col === 3"><img src="assets/img/global/{{imagem}}" alt="3" height="16"
                      width="16">&nbsp;</span>NOME
                </a>
              </th>
              <th scope="col">
                <a href="javascript:;" (click)="ordenar(4)" class="text-black-50">
                  <span *ngIf="col === 4"><img src="assets/img/global/{{imagem}}" alt="3" height="16"
                      width="16">&nbsp;</span>ÓRGÃO
                </a>
              </th>
              <th scope="col" style="width: 100px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <td class="text-center">{{item.ano}}</td>
              <td class="text-center">{{retornarReferencia(item)}}</td>
              <td>{{item.nome}}</td>
              <td>{{item.orgao.nome}}</td>
              <td class="text-center">
                <a href="javascript:void" (click)="visualizar(item)">
                  <img src="assets/img/global/page_white.png" alt="cvs" title="visualizar" height="22" width="22">
                  Visualizar
                </a>
                <a href="javascript:void" (click)="download(item)">
                  <img src="assets/img/global/download_cloud.png" alt="cvs" title="download" height="22" width="22">
                  Baixar
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
    <div class="row" *ngIf="lista.length === 0">
      <div class="col-12 mt-5 ml-3">
        <img src="assets/img/global/warning.png" alt="atencao" class="mb-1">
        <br />
        <span style="color: #6a6a6a; font-weight: bold;">NÃO HÁ LANÇAMENTOS EFETUADOS NESTE PERÍODO ! </span>
      </div>
    </div>
  </div>
</div>